document.documentElement.classList.remove('no-js');
document.documentElement.classList.add('js');

function initMenu(root = document) {
  const menu = root.querySelector('[data-mobile-menu]') || document.querySelector('[data-mobile-menu]');
  const open = root.querySelector('[data-menu-open]') || document.querySelector('[data-menu-open]');
  const close = root.querySelector('[data-menu-close]') || document.querySelector('[data-menu-close]');
  if (!menu || !open || !close || open.dataset.ready) return;
  open.dataset.ready = 'true';
  const toggle = (show) => { menu.classList.toggle('is-open', show); menu.setAttribute('aria-hidden', String(!show)); document.body.style.overflow = show ? 'hidden' : ''; };
  open.addEventListener('click', () => toggle(true)); close.addEventListener('click', () => toggle(false));
  document.addEventListener('keydown', (event) => { if (event.key === 'Escape') toggle(false); });
}

function initProduct(root = document) {
  root.querySelectorAll('[data-product-section]').forEach((section) => {
    if (section.dataset.ready) return; section.dataset.ready = 'true';
    const select = section.querySelector('[data-variant-select]');
    const price = section.querySelector('[data-product-price]');
    const form = section.querySelector('[data-product-form]');
    if (!form) return;
    const button = form.querySelector('[type="submit"]');
    const label = form.querySelector('[data-add-label]');
    const available = () => !select || select.selectedOptions[0]?.dataset.available !== 'false';
    let busy = false;
    let resetLabel;
    const setAddState = (state, text) => {
      button.dataset.addState = state;
      button.setAttribute('aria-busy', String(state === 'pending'));
      if (!label) return;
      label.textContent = text;
      if (!matchMedia('(prefers-reduced-motion: reduce)').matches) {
        label.getAnimations().forEach(animation => animation.cancel());
        label.animate([{opacity:0,transform:'translateY(4px)'},{opacity:1,transform:'translateY(0)'}],{duration:180,easing:'ease-out'});
      }
    };
    const updateVariant = () => {
      clearTimeout(resetLabel);
      const option = select?.selectedOptions[0];
      if (price && option) price.textContent = option.dataset.price;
      button.disabled = busy || !available();
      setAddState(busy ? 'pending' : 'idle', busy ? 'Adding…' : available() ? 'Add to bag' : 'Sold out');
      section.querySelectorAll('[data-variant-id]').forEach(node => node.setAttribute('aria-pressed',String(node.dataset.variantId === select?.value)));
      const photo = section.querySelector('[data-card-image]');
      if (photo && option?.dataset.image) { photo.src = option.dataset.image; photo.alt = section.querySelector('h3')?.textContent + ' — ' + option.textContent; }
      if (section.matches('.product-page') && option) {
        const url = new URL(location.href); url.searchParams.set('variant',option.value); history.replaceState({},'',url);
        const gallery = section.querySelector('[data-gallery]');
        if (gallery && option.dataset.image) gallery.dispatchEvent(new CustomEvent('gallery:variant',{detail:{src:option.dataset.image,alt:section.querySelector('h1').textContent + ' — ' + option.textContent}}));
      }
    };
    select?.addEventListener('change',updateVariant);
    if (select && section.matches('.product-page') && section.querySelector('[data-variant-buttons]')) select.hidden = true;
    section.querySelectorAll('[data-variant-id]').forEach(node => node.addEventListener('click',()=>{select.value=node.dataset.variantId;select.dispatchEvent(new Event('change',{bubbles:true}));}));
    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      if (busy || button?.disabled) return;
      clearTimeout(resetLabel);
      const feedback = form.querySelector('[data-product-feedback]');
      if (feedback) { feedback.textContent = ''; feedback.classList.remove('visually-hidden'); }
      const rootUrl = window.Shopify?.routes?.root || '/';
      const addedPreview = {variantId:form.querySelector('[name="id"]').value, image:select?.selectedOptions[0]?.dataset.image || section.querySelector('[data-card-image], [data-gallery-image]')?.src};
      busy = true; if (button) button.disabled = true;
      setAddState('pending', 'Adding…');
      try {
        const response = await fetch(`${rootUrl}cart/add.js`, { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
        if (!response.ok) {
          const failure = await response.json().catch(() => ({}));
          throw new Error(failure.description || 'Unable to add this item. Please try again.');
        }
        try {
          const cartResponse = await fetch(`${rootUrl}cart.js`, { cache: 'no-store' });
          if (!cartResponse.ok) throw new Error('Cart refresh failed');
          const cart = await cartResponse.json();
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart, source: 'add', addedPreview } }));
        } catch { document.dispatchEvent(new CustomEvent('cart:add-refresh-failed')); }
        setAddState('success', 'Added to bag');
        if (feedback) { feedback.classList.add('visually-hidden'); feedback.textContent = 'Added to your bag.'; }
        resetLabel = setTimeout(() => setAddState('idle', available() ? 'Add to bag' : 'Sold out'), 1800);
      } catch (error) { if (feedback) feedback.textContent = error.message || 'Please try again.'; setAddState('idle',available()?'Add to bag':'Sold out'); }
      finally { busy = false; if (button) button.disabled = !available(); }
    });
  });
}

function initScentFinder(root = document) {
  root.querySelectorAll('[data-scent-finder]').forEach((finder) => {
    if (finder.dataset.ready) return; finder.dataset.ready = 'true';
    let step = 0; let mood = 'radiant'; const steps = [...finder.querySelectorAll('[data-step]')];
    const show = (number) => { step = number; steps.forEach((node) => { node.hidden = Number(node.dataset.step) !== number; }); };
    finder.querySelectorAll('[data-answer]').forEach((button) => button.addEventListener('click', () => { mood = button.dataset.answer; show(1); }));
    finder.querySelectorAll('[data-next]').forEach((button) => button.addEventListener('click', () => show(2)));
    finder.querySelectorAll('[data-result]').forEach((button) => button.addEventListener('click', () => { finder.querySelectorAll('[data-match]').forEach((match) => { match.hidden = true; }); const match = finder.querySelector(`[data-match="${mood}"]`); const fallback = finder.querySelector('[data-match="fallback"]'); if (match) match.hidden = false; else if (fallback) fallback.hidden = false; show(3); }));
    finder.querySelectorAll('[data-back]').forEach((button) => button.addEventListener('click', () => show(Math.max(0, step - 1))));
    finder.querySelector('[data-restart]')?.addEventListener('click', () => show(0));
    const requestedMood = new URLSearchParams(location.search).get('mood');
    if (['radiant', 'romantic', 'grounded', 'bold'].includes(requestedMood)) {
      mood = requestedMood;
      show(1);
    }
  });
}

function initTestimonials(root = document) {
  root.querySelectorAll('[data-testimonials]').forEach((slider) => {
    const slides = [...slider.querySelectorAll('[data-testimonial]')]; if (slides.length < 2 || slider.dataset.ready) return; slider.dataset.ready = 'true'; let current = 0;
    setInterval(() => { slides[current].classList.add('is-hidden'); current = (current + 1) % slides.length; slides[current].classList.remove('is-hidden'); }, 6000);
  });
}

function initTheme(root = document) { initMenu(root); initProduct(root); initScentFinder(root); initTestimonials(root); }
document.addEventListener('DOMContentLoaded', () => initTheme());
document.addEventListener('shopify:section:load', (event) => initTheme(event.target));
